import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconMaskClose = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...omit(props, ["className"])}
      className="yfm-icon yfm-icon-mask-close"
      ref={ref}
    >
      <circle cx="8" cy="8" r="8" fill={props.color} />
      <path
        d="M11.6134 10.9567L5.04344 4.38608C4.86156 4.20482 4.56719 4.20482 4.38594 4.38608C4.20469 4.56733 4.20469 4.8617 4.38594 5.04357L10.9559 11.6136C11.1378 11.7948 11.4322 11.7948 11.6134 11.6136C11.7947 11.4323 11.7947 11.1379 11.6134 10.9567Z"
        fill="white"
      />
      <path
        d="M11.6134 4.38608C11.4322 4.20482 11.1378 4.20482 10.9559 4.38608L4.38594 10.9567C4.20469 11.1386 4.20469 11.4323 4.38594 11.6136C4.56719 11.7948 4.86156 11.7948 5.04344 11.6136L11.6134 5.04357C11.7947 4.8617 11.7947 4.56733 11.6134 4.38608Z"
        fill="white"
      />
    </svg>
  )
);

IconMaskClose.displayName = "IconMaskClose";

export default IconMaskClose;
